import { useEffect, useState } from "react";

/**
 * Minimal OAuth callback page — shown inside the OAuth popup after the
 * provider redirects back. Reads integration_connected / integration_error
 * from the URL, notifies the opener, then closes itself.
 */
export default function OAuthCallback() {
  const [status, setStatus] = useState("connecting");

  useEffect(() => {
    const url = new URL(window.location.href);
    const connected = url.searchParams.get("integration_connected");
    const error = url.searchParams.get("integration_error");

    if (connected) {
      setStatus("success");
      // Notify parent window
      if (window.opener) {
        window.opener.dispatchEvent(new CustomEvent("crescendo:integration-connected", {
          detail: { provider: connected }
        }));
      }
    } else if (error) {
      setStatus("error");
      if (window.opener) {
        window.opener.dispatchEvent(new CustomEvent("crescendo:integration-error", {
          detail: { error }
        }));
      }
    }

    // Close after a brief moment so user sees the confirmation
    const t = setTimeout(() => window.close(), 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={{
      minHeight: "100vh",
      background: "#0A0A0A",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "system-ui, sans-serif",
      color: "#EDEDED",
      gap: "12px",
    }}>
      {status === "success" && (
        <>
          <div style={{ fontSize: 40 }}>✓</div>
          <div style={{ fontSize: 15, color: "#5A90F5" }}>Connected! Closing…</div>
        </>
      )}
      {status === "error" && (
        <>
          <div style={{ fontSize: 40 }}>✗</div>
          <div style={{ fontSize: 15, color: "#EF4444" }}>Connection failed. Closing…</div>
        </>
      )}
      {status === "connecting" && (
        <div style={{ fontSize: 15, color: "#71717A" }}>Finishing connection…</div>
      )}
    </div>
  );
}
